import { Type } from "class-transformer";
import { JobResult } from "./JobResult";

export class EnaioWatcherResult {
    message: string;
    @Type(() => JobResult)
    jobResult: JobResult;
}
